










import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import DeciLeft from './components/decision-left.vue';
@Component({
  components: { DeciLeft }
})
export default class Decision extends Vue {
  @State MENU_INDENT: any;

  async created() {}
}
